/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CarrierRequestStatus {
  AWAITING_EMPLOYEE = 'AWAITING_EMPLOYEE',
  CONFIRMED_BY_EMPLOYEE = 'CONFIRMED_BY_EMPLOYEE',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
}
